<div class="question question-borg">
    <h2>{{ question.title }}</h2>
    <h3>{{ question.help }}</h3>

    <app-feedback-borg-answer [previousAnswers]="previousAnswers" [answeredAnswers]="answeredAnswers" [feedback]="feedback" [question]="question" [hasAnsweredQuestion]="hasAnsweredQuestion" (onAnswerChange)="answerChanged($event)" (onNextQuestionClicked)="onNextQuestionClicked($event)"></app-feedback-borg-answer>
</div>

<!--
<div class="back" *ngIf="hasAnsweredQuestion">
    <button mat-icon-button color="primary" (click)="onPreviousQuestionClicked(question)">
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>
-->
